import userImg from "../../assets/images/user.svg";
import { Dialog } from "../../components/CommonComponents/Dialog/Dialog";
import { TReviewWithReviewer } from "../../hooks/level-1-application-approval.hooks";
import { formatDate } from "../../utils/date";

export function RenderAllReviews({
  reviews,
  onClose,
  title = "Previous Reviews",
}: {
  title?: string;
  reviews: TReviewWithReviewer[];
  onClose: () => unknown;
}) {
  // Sort reviews by date in descending order (most recent first)
  const sortedReviews = [...reviews].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <Dialog onClose={onClose} open className="md:w-3/5 md:h-4/5">
      <div className="p-4 md:p-8 h-full flex overflow-auto flex-col">
        <div className="mb-4 md:mb-8 flex justify-center items-center">
          <h4 className="m-0 grow text-center text-2xl font-bold">{title}</h4>
          <button className="text-xl" onClick={onClose}>
            <i className="fa fa-close"></i>
          </button>
        </div>
        <hr className="p-2 md:p-4"/>
        <div className="w-full grow overflow-auto pr-4">
          {sortedReviews.map((each, i) => (
            <div
              key={`review-${each.id}`}
              className="flex justify-between min-h-[100px]"
            >
              <div className="basis-20 md:basis-40 flex shrink-0 flex-col items-center">
                <img src={userImg} height={72} width={72} alt="profile-pic" />
                {!!sortedReviews[i + 1] && (
                  <div className="grow border md:border-2 border-primary"></div>
                )}
              </div>
              <div className="grow px-1 pt-1 pb-4">
                <div className="flex justify-between mb-2">
                  <h6 className="text-base md:text-lg font-bold">
                    {each.reviewer?.name || "--"}
                    <span className="font-normal inline-block ml-4">
                      {each?.level || ""}
                    </span>
                  </h6>
                  <h6 className="hidden md:block md:text-lg font-bold">
                    {`Date - ${formatDate(each.date || "")}`}
                  </h6>
                </div>
                <p>{each.comment_text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Dialog>
  );
}